module.exports = __webpack_public_path__ + "img/declinedCircle.50ed47bd.svg";